import script from "./GalleriesAll.vue?vue&type=script&setup=true&lang=ts"
export * from "./GalleriesAll.vue?vue&type=script&setup=true&lang=ts"

import "./GalleriesAll.vue?vue&type=style&index=0&id=df553c4e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df553c4e"]])

export default __exports__